import { isNullOrUndefined } from '@syncfusion/ej2-base';
import { Dictionary } from '../../base/dictionary';
import { WUniqueFormat } from '../../base/unique-format';
import { WUniqueFormats } from '../../base/unique-formats';
/* eslint-disable */
/**
 * @private
 */
export class WSectionFormat {
    constructor(node) {
        this.uniqueSectionFormat = undefined;
        this.columns = [];
        this.ownerBase = node;
        this.columns = [];
        this.removedHeaderFooters = [];
    }
    get headerDistance() {
        return this.getPropertyValue('headerDistance');
    }
    set headerDistance(value) {
        this.setPropertyValue('headerDistance', value);
    }
    get footerDistance() {
        return this.getPropertyValue('footerDistance');
    }
    set footerDistance(value) {
        this.setPropertyValue('footerDistance', value);
    }
    get differentFirstPage() {
        return this.getPropertyValue('differentFirstPage');
    }
    set differentFirstPage(value) {
        this.setPropertyValue('differentFirstPage', value);
    }
    get differentOddAndEvenPages() {
        return this.getPropertyValue('differentOddAndEvenPages');
    }
    set differentOddAndEvenPages(value) {
        this.setPropertyValue('differentOddAndEvenPages', value);
    }
    get pageHeight() {
        return this.getPropertyValue('pageHeight');
    }
    set pageHeight(value) {
        this.setPropertyValue('pageHeight', value);
    }
    get rightMargin() {
        return this.getPropertyValue('rightMargin');
    }
    set rightMargin(value) {
        this.setPropertyValue('rightMargin', value);
    }
    get pageWidth() {
        return this.getPropertyValue('pageWidth');
    }
    set pageWidth(value) {
        this.setPropertyValue('pageWidth', value);
    }
    get leftMargin() {
        return this.getPropertyValue('leftMargin');
    }
    set leftMargin(value) {
        this.setPropertyValue('leftMargin', value);
    }
    get bottomMargin() {
        return this.getPropertyValue('bottomMargin');
    }
    set bottomMargin(value) {
        this.setPropertyValue('bottomMargin', value);
    }
    get topMargin() {
        return this.getPropertyValue('topMargin');
    }
    set topMargin(value) {
        this.setPropertyValue('topMargin', value);
    }
    get bidi() {
        return this.getPropertyValue('bidi');
    }
    set bidi(value) {
        this.setPropertyValue('bidi', value);
    }
    get restartPageNumbering() {
        return this.getPropertyValue('restartPageNumbering');
    }
    set restartPageNumbering(value) {
        this.setPropertyValue('restartPageNumbering', value);
    }
    get pageStartingNumber() {
        return this.getPropertyValue('pageStartingNumber');
    }
    set pageStartingNumber(value) {
        this.setPropertyValue('pageStartingNumber', value);
    }
    get endnoteNumberFormat() {
        return this.getPropertyValue('endnoteNumberFormat');
    }
    set endnoteNumberFormat(value) {
        this.setPropertyValue('endnoteNumberFormat', value);
    }
    get restartIndexForEndnotes() {
        return this.getPropertyValue('restartIndexForEndnotes');
    }
    set restartIndexForEndnotes(value) {
        this.setPropertyValue('restartIndexForEndnotes', value);
    }
    get restartIndexForFootnotes() {
        return this.getPropertyValue('restartIndexForFootnotes');
    }
    set restartIndexForFootnotes(value) {
        this.setPropertyValue('restartIndexForFootnotes', value);
    }
    get footNoteNumberFormat() {
        return this.getPropertyValue('footNoteNumberFormat');
    }
    set footNoteNumberFormat(value) {
        this.setPropertyValue('footNoteNumberFormat', value);
    }
    get initialFootNoteNumber() {
        return this.getPropertyValue('initialFootNoteNumber');
    }
    set initialFootNoteNumber(value) {
        this.setPropertyValue('initialFootNoteNumber', value);
    }
    get initialEndNoteNumber() {
        return this.getPropertyValue('initialEndNoteNumber');
    }
    set initialEndNoteNumber(value) {
        this.setPropertyValue('initialEndNoteNumber', value);
    }
    get pageNumberStyle() {
        return this.getPropertyValue('pageNumberStyle');
    }
    set pageNumberStyle(value) {
        this.setPropertyValue('pageNumberStyle', value);
    }
    get numberOfColumns() {
        return this.getPropertyValue('numberOfColumns');
    }
    set numberOfColumns(value) {
        this.setPropertyValue('numberOfColumns', value);
    }
    get equalWidth() {
        return this.getPropertyValue('equalWidth');
    }
    set equalWidth(value) {
        this.setPropertyValue('equalWidth', value);
    }
    get lineBetweenColumns() {
        return this.getPropertyValue('lineBetweenColumns');
    }
    set lineBetweenColumns(value) {
        this.setPropertyValue('lineBetweenColumns', value);
    }
    get breakCode() {
        return this.getPropertyValue('breakCode');
    }
    set breakCode(value) {
        this.setPropertyValue('breakCode', value);
    }
    set firstPageHeader(value) {
        this.setPropertyValue('firstPageHeader', value);
    }
    get firstPageHeader() {
        return this.getPropertyValue('firstPageHeader');
    }
    set firstPageFooter(value) {
        this.setPropertyValue('firstPageFooter', value);
    }
    get firstPageFooter() {
        return this.getPropertyValue('firstPageFooter');
    }
    set oddPageHeader(value) {
        this.setPropertyValue('oddPageHeader', value);
    }
    get oddPageHeader() {
        return this.getPropertyValue('oddPageHeader');
    }
    set oddPageFooter(value) {
        this.setPropertyValue('oddPageFooter', value);
    }
    get oddPageFooter() {
        return this.getPropertyValue('oddPageFooter');
    }
    set evenPageHeader(value) {
        this.setPropertyValue('evenPageHeader', value);
    }
    get evenPageHeader() {
        return this.getPropertyValue('evenPageHeader');
    }
    set evenPageFooter(value) {
        this.setPropertyValue('evenPageFooter', value);
    }
    get evenPageFooter() {
        return this.getPropertyValue('evenPageFooter');
    }
    destroy() {
        if (!isNullOrUndefined(this.uniqueSectionFormat)) {
            WSectionFormat.uniqueSectionFormats.remove(this.uniqueSectionFormat);
        }
        this.uniqueSectionFormat = undefined;
        this.ownerBase = undefined;
        this.columns = undefined;
        this.removedHeaderFooters = undefined;
    }
    /**
     * @private
     */
    hasValue(property) {
        if (!isNullOrUndefined(this.uniqueSectionFormat)) {
            const propertyType = WUniqueFormat.getPropertyType(this.uniqueSectionFormat.uniqueFormatType, property);
            return this.uniqueSectionFormat.propertiesHash.containsKey(propertyType);
        }
        return false;
    }
    static getPropertyDefaultValue(property) {
        let value = undefined;
        switch (property) {
            case 'headerDistance':
                value = 36;
                break;
            case 'footerDistance':
                value = 36;
                break;
            case 'differentFirstPage':
                value = false;
                break;
            case 'differentOddAndEvenPages':
                value = false;
                break;
            case 'pageWidth':
                value = 612;
                break;
            case 'pageHeight':
                value = 792;
                break;
            case 'leftMargin':
                value = 72;
                break;
            case 'topMargin':
                value = 72;
                break;
            case 'rightMargin':
                value = 72;
                break;
            case 'bottomMargin':
                value = 72;
                break;
            case 'bidi':
                value = false;
                break;
            case 'restartPageNumbering':
                value = false;
                break;
            case 'pageStartingNumber':
                value = 1;
                break;
            case 'footnotePosition':
                value = 'PrintAtBottomOfPage';
                break;
            case 'endnoteNumberFormat':
                value = 'LowerCaseRoman';
                break;
            case 'endnotePosition':
                value = 'DisplayEndOfDocument';
                break;
            case 'restartIndexForEndnotes':
                value = 'DoNotRestart';
                break;
            case 'restartIndexForFootnotes':
                value = 'DoNotRestart';
                break;
            case 'footNoteNumberFormat':
                value = 'Arabic';
                break;
            case 'initialFootNoteNumber':
                value = 1;
                break;
            case 'initialEndNoteNumber':
                value = 1;
                break;
            case 'pageNumberStyle':
                value = 'Arabic';
                break;
            case 'numberOfColumns':
                value = 1;
                break;
            case 'equalWidth':
                value = true;
                break;
            case 'lineBetweenColumns':
                value = false;
                break;
            case 'breakCode':
                value = 'NewPage';
                break;
            case 'firstPageHeader':
                value = undefined;
                break;
            case 'firstPageFooter':
                value = undefined;
                break;
            case 'oddPageHeader':
                value = undefined;
                break;
            case 'oddPageFooter':
                value = undefined;
                break;
            case 'evenPageHeader':
                value = undefined;
                break;
            case 'evenPageFooter':
                value = undefined;
                break;
        }
        return value;
    }
    getPropertyValue(property) {
        const hasValue = this.hasValue(property);
        if (hasValue) {
            const propertyType = WUniqueFormat.getPropertyType(WSectionFormat.uniqueFormatType, property);
            if (!isNullOrUndefined(this.uniqueSectionFormat) && this.uniqueSectionFormat.propertiesHash.containsKey(propertyType)) {
                return this.uniqueSectionFormat.propertiesHash.get(propertyType);
            }
        }
        return WSectionFormat.getPropertyDefaultValue(property);
    }
    setPropertyValue(property, value) {
        if (isNullOrUndefined(value) || value === '') {
            value = WSectionFormat.getPropertyDefaultValue(property);
        }
        if (isNullOrUndefined(this.uniqueSectionFormat)) {
            this.initializeUniqueSectionFormat(property, value);
        }
        else {
            const propertyType = WUniqueFormat.getPropertyType(this.uniqueSectionFormat.uniqueFormatType, property);
            if (this.uniqueSectionFormat.propertiesHash.containsKey(propertyType) &&
                this.uniqueSectionFormat.propertiesHash.get(propertyType) === value) {
                //Do nothing, since no change in property value and return
                return;
            }
            this.uniqueSectionFormat = WSectionFormat.uniqueSectionFormats.updateUniqueFormat(this.uniqueSectionFormat, property, value);
        }
    }
    initializeUniqueSectionFormat(property, propValue) {
        const uniqueSectionFormatTemp = new Dictionary();
        this.addUniqueSectionFormat('headerDistance', property, propValue, uniqueSectionFormatTemp);
        this.addUniqueSectionFormat('footerDistance', property, propValue, uniqueSectionFormatTemp);
        this.addUniqueSectionFormat('differentFirstPage', property, propValue, uniqueSectionFormatTemp);
        this.addUniqueSectionFormat('differentOddAndEvenPages', property, propValue, uniqueSectionFormatTemp);
        this.addUniqueSectionFormat('pageWidth', property, propValue, uniqueSectionFormatTemp);
        this.addUniqueSectionFormat('pageHeight', property, propValue, uniqueSectionFormatTemp);
        this.addUniqueSectionFormat('leftMargin', property, propValue, uniqueSectionFormatTemp);
        this.addUniqueSectionFormat('topMargin', property, propValue, uniqueSectionFormatTemp);
        this.addUniqueSectionFormat('rightMargin', property, propValue, uniqueSectionFormatTemp);
        this.addUniqueSectionFormat('bottomMargin', property, propValue, uniqueSectionFormatTemp);
        this.addUniqueSectionFormat('bidi', property, propValue, uniqueSectionFormatTemp);
        this.addUniqueSectionFormat('restartPageNumbering', property, propValue, uniqueSectionFormatTemp);
        this.addUniqueSectionFormat('pageStartingNumber', property, propValue, uniqueSectionFormatTemp);
        this.addUniqueSectionFormat('endnoteNumberFormat', property, propValue, uniqueSectionFormatTemp);
        this.addUniqueSectionFormat('endnotePosition', property, propValue, uniqueSectionFormatTemp);
        this.addUniqueSectionFormat('footNoteNumberFormat', property, propValue, uniqueSectionFormatTemp);
        this.addUniqueSectionFormat('footnotePosition', property, propValue, uniqueSectionFormatTemp);
        this.addUniqueSectionFormat('restartIndexForEndnotes', property, propValue, uniqueSectionFormatTemp);
        this.addUniqueSectionFormat('restartIndexForFootnotes', property, propValue, uniqueSectionFormatTemp);
        this.addUniqueSectionFormat('initialFootNoteNumber', property, propValue, uniqueSectionFormatTemp);
        this.addUniqueSectionFormat('initialEndNoteNumber', property, propValue, uniqueSectionFormatTemp);
        this.addUniqueSectionFormat('pageNumberStyle', property, propValue, uniqueSectionFormatTemp);
        this.addUniqueSectionFormat('numberOfColumns', property, propValue, uniqueSectionFormatTemp);
        this.addUniqueSectionFormat('equalWidth', property, propValue, uniqueSectionFormatTemp);
        this.addUniqueSectionFormat('lineBetweenColumns', property, propValue, uniqueSectionFormatTemp);
        this.addUniqueSectionFormat('breakCode', property, propValue, uniqueSectionFormatTemp);
        this.uniqueSectionFormat = WSectionFormat.uniqueSectionFormats.addUniqueFormat(uniqueSectionFormatTemp, WSectionFormat.uniqueFormatType);
    }
    addUniqueSectionFormat(property, modifiedProperty, propValue, uniqueSectionFormatTemp) {
        const propertyType = WUniqueFormat.getPropertyType(WSectionFormat.uniqueFormatType, property);
        if (property === modifiedProperty) {
            uniqueSectionFormatTemp.add(propertyType, propValue);
        }
        else {
            uniqueSectionFormatTemp.add(propertyType, WSectionFormat.getPropertyDefaultValue(property));
        }
    }
    copyFormat(format, history) {
        if (history && (history.isUndoing || history.isRedoing)) {
            this.uniqueSectionFormat = format.uniqueSectionFormat;
            this.columns = format.columns;
            this.removedHeaderFooters = format.removedHeaderFooters;
        }
        else {
            if (!isNullOrUndefined(format)) {
                this.removedHeaderFooters = format.removedHeaderFooters;
                if (!isNullOrUndefined(format.uniqueSectionFormat) && format.uniqueSectionFormat.propertiesHash) {
                    this.updateUniqueSectionFormat(format);
                    this.columns = format.columns;
                }
            }
        }
    }
    updateUniqueSectionFormat(format) {
        let hash = undefined;
        if (this.uniqueSectionFormat) {
            hash = this.uniqueSectionFormat.mergeProperties(format.uniqueSectionFormat);
            if (this.uniqueSectionFormat.referenceCount === 0) {
                WSectionFormat.uniqueSectionFormats.remove(this.uniqueSectionFormat);
                this.uniqueSectionFormat = undefined;
            }
        }
        this.uniqueSectionFormat = new WUniqueFormat(WSectionFormat.uniqueFormatType);
        if (isNullOrUndefined(hash)) {
            hash = this.uniqueSectionFormat.mergeProperties(format.uniqueSectionFormat);
        }
        this.uniqueSectionFormat = WSectionFormat.uniqueSectionFormats.addUniqueFormat(hash, WSectionFormat.uniqueFormatType);
    }
    cloneFormat() {
        const format = new WSectionFormat();
        format.uniqueSectionFormat = this.uniqueSectionFormat;
        format.columns = this.columns;
        return format;
    }
    static clear() {
        this.uniqueSectionFormats.clear();
    }
}
WSectionFormat.uniqueSectionFormats = new WUniqueFormats();
WSectionFormat.uniqueFormatType = 10;
/**
 * @private
 */
export class WColumnFormat {
    constructor(node) {
        this.uniqueColumnFormat = undefined;
        this.ownerBase = node;
    }
    destroy() {
        if (!isNullOrUndefined(this.uniqueColumnFormat)) {
            WColumnFormat.uniqueColumnFormats.remove(this.uniqueColumnFormat);
        }
        this.uniqueColumnFormat = undefined;
        this.ownerBase = undefined;
    }
    hasValue(property) {
        if (!isNullOrUndefined(this.uniqueColumnFormat)) {
            const propertyType = WUniqueFormat.getPropertyType(this.uniqueColumnFormat.uniqueFormatType, property);
            return this.uniqueColumnFormat.propertiesHash.containsKey(propertyType);
        }
        return false;
    }
    get index() {
        return this.indexIn;
    }
    set index(value) {
        this.indexIn = value;
    }
    get width() {
        return this.getPropertyValue('width');
    }
    set width(value) {
        this.setPropertyValue('width', value);
    }
    get space() {
        return this.getPropertyValue('space');
    }
    set space(value) {
        this.setPropertyValue('space', value);
    }
    getPropertyValue(property) {
        const hasValue = this.hasValue(property);
        if (hasValue) {
            const propertyType = WUniqueFormat.getPropertyType(WColumnFormat.uniqueFormatType, property);
            if (!isNullOrUndefined(this.uniqueColumnFormat) && this.uniqueColumnFormat.propertiesHash.containsKey(propertyType)) {
                return this.uniqueColumnFormat.propertiesHash.get(propertyType);
            }
        }
        return WColumnFormat.getPropertyDefaultValue(property);
    }
    static getPropertyDefaultValue(property) {
        let value = undefined;
        switch (property) {
            case 'width':
                value = 36;
                break;
            case 'space':
                value = 0;
                break;
        }
        return value;
    }
    setPropertyValue(property, value) {
        if (isNullOrUndefined(value) || value === '') {
            value = WColumnFormat.getPropertyDefaultValue(property);
        }
        if (isNullOrUndefined(this.uniqueColumnFormat)) {
            this.initializeUniqueColumnFormat(property, value);
        }
        else {
            const propertyType = WUniqueFormat.getPropertyType(this.uniqueColumnFormat.uniqueFormatType, property);
            if (this.uniqueColumnFormat.propertiesHash.containsKey(propertyType) &&
                this.uniqueColumnFormat.propertiesHash.get(propertyType) === value) {
                //Do nothing, since no change in property value and return
                return;
            }
            this.uniqueColumnFormat = WColumnFormat.uniqueColumnFormats.updateUniqueFormat(this.uniqueColumnFormat, property, value);
        }
    }
    initializeUniqueColumnFormat(property, propValue) {
        const uniqueColumnFormatTemp = new Dictionary();
        this.addUniqueColumnFormat('width', property, propValue, uniqueColumnFormatTemp);
        this.addUniqueColumnFormat('space', property, propValue, uniqueColumnFormatTemp);
        this.uniqueColumnFormat = WColumnFormat.uniqueColumnFormats.addUniqueFormat(uniqueColumnFormatTemp, WColumnFormat.uniqueFormatType);
    }
    addUniqueColumnFormat(property, modifiedProperty, propValue, uniqueColumnFormatTemp) {
        const propertyType = WUniqueFormat.getPropertyType(WColumnFormat.uniqueFormatType, property);
        if (property === modifiedProperty) {
            uniqueColumnFormatTemp.add(propertyType, propValue);
        }
        else {
            uniqueColumnFormatTemp.add(propertyType, WColumnFormat.getPropertyDefaultValue(property));
        }
    }
    updateUniqueColumnFormat(format) {
        let hash = undefined;
        if (this.uniqueColumnFormat) {
            hash = this.uniqueColumnFormat.mergeProperties(format.uniqueColumnFormat);
            if (this.uniqueColumnFormat.referenceCount === 0) {
                WColumnFormat.uniqueColumnFormats.remove(this.uniqueColumnFormat);
                this.uniqueColumnFormat = undefined;
            }
        }
        this.uniqueColumnFormat = new WUniqueFormat(WColumnFormat.uniqueFormatType);
        if (isNullOrUndefined(hash)) {
            hash = this.uniqueColumnFormat.mergeProperties(format.uniqueColumnFormat);
        }
        this.uniqueColumnFormat = WColumnFormat.uniqueColumnFormats.addUniqueFormat(hash, WColumnFormat.uniqueFormatType);
    }
    cloneFormat() {
        const colFormat = new WColumnFormat(undefined);
        colFormat.width = this.width;
        colFormat.space = this.space;
        return colFormat;
    }
    copyFormat(colFormat) {
        if (!isNullOrUndefined(colFormat) && !isNullOrUndefined(colFormat.uniqueColumnFormat)) {
            this.width = colFormat.width;
            this.space = colFormat.space;
        }
    }
    static clear() {
        this.uniqueColumnFormats.clear();
    }
}
WColumnFormat.uniqueColumnFormats = new WUniqueFormats();
WColumnFormat.uniqueFormatType = 11;
